import React, { useEffect, useState } from "react";
import Api from "../../../config/Api";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
// import GifImg from "../../../assets/images/loader.gif";
// import InfiniteScroll from "react-infinite-scroller";
// import qs from "qs";
import { useForm } from "react-hook-form";
import { BsEyeFill } from "react-icons/bs";
import StatusBadge from "../Application/Components/StatusBadge";
import Table from "../../Components/Widget/Table";
import Loader from "../../Components/Widget/Loader";
import TooltipWidget from "../../Components/Widget/TooltipWidget";

const FinalApprovedApplicationsList = () => {
  const {
    formState: { errors },
    reset,
  } = useForm();

  // const ImgUrl = "https://cdn-icons-png.flaticon.com/512/219/219983.png";
  const [isLoading, setIsLoading] = useState(false);
  const [application, setApplication] = useState([]);
  const [isApplicationLoaded, setIsApplicationLoaded] = useState(false);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const admin = useSelector((state) => JSON.parse(state.authentication.admin));

  //Application Get
  const getApplication = async (
    status_id,
    page = 1,
    search = "",
    pageSize = perPage,
    sortByArg = sortBy,
    sortDirArg = sortDirection
  ) => {
    try {
      setIsLoading(true);
      const body = {
        status_id: status_id,
        page_no: page,
        per_page: pageSize,
      };

      if (search.trim()) {
        body.search = search.trim();
      }

      if (sortByArg) {
        body.sort_by = sortByArg;
        body.sort_direction = sortDirArg;
      }

      const res = await Api("application_list", "POST", body, true);

      if (res.data.status === 1) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        const applicationData = Array.isArray(res.data.data) ? res.data.data : [];
        const paginationData =
          res.data.pagination &&
          typeof res.data.pagination === "object"
            ? res.data.pagination
            : res.data &&
              typeof res.data === "object" &&
              res.data.page
            ? {
                page_no: res.data.page,
                per_page: res.data.per_page,
                total_pages: res.data.total_pages,
                total_records: res.data.total,
              }
            : null;

        setApplication(applicationData);

        if (paginationData) {
          setCurrentPage(paginationData.page_no || page);
          setTotalPages(paginationData.total_pages || 1);
          setTotalRecords(paginationData.total_records || 0);
          setPerPage(paginationData.per_page || pageSize);
        } else {
          const total =
            res.data.total || res.data.count || applicationData.length;
          setCurrentPage(page);
          setTotalPages(Math.max(Math.ceil(total / pageSize), 1));
          setTotalRecords(total);
          setPerPage(pageSize);
        }

        setIsApplicationLoaded(true);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error?.data?.message || "Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };
  //Application Get

  const handleSearchInput = (value) => {
    setFilter(value);

    if (value.trim() === "") {
      setCurrentPage(1);
      setResetPaginationToggle((prev) => !prev);
      getApplication([6], 1, "", perPage);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setResetPaginationToggle((prev) => !prev);
    getApplication([6], 1, filter, perPage);
  };

  useEffect(() => {
    getApplication([6]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!!admin) {
      reset({
        name: admin.full_name,
      });
    }
    // eslint-disable-next-line
  }, [reset]);

  const columns = [
    {
      name: "#",
      cell: (_row, index) => (currentPage - 1) * perPage + index + 1,
      width: "70px",
    },
    {
      name: "Application ID",
      selector: (row) => row.application_id,
      sortable: true,
      wrap: true,
    },
    {
    //   name: "Applicant Image",
    name: "Applicant Passport Photo",
      selector: (row) => (
        <img
          src={row.applicant_default_img}
          alt="Applicant"
          style={{
            height: "70px",
            width: "100px",
            objectFit: "cover",
          }}
        />
      ),
    },
    {
      name: "Applicant Info",
      selector: (row) => (
        <>
          <div className="mb-1">{row.applicant_name}</div>
          <div>{row.mobile}</div>
        </>
      ),
    },
    {
      name: "District",
      selector: (row) => row.district?.district_name,
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "Status",
    //   selector: (row) => <StatusBadge status={row.status} />,
    //   sortable: true,
    //   wrap: true,
    // },
    {
        name: "Status",
        selector: (row) => {
         if(row?.payment_status === 'R'){
          return (
          <>
          <StatusBadge status={row.status} /><span style={{backgroundColor: 'red',
              color: 'white',
              padding: '4px 6px',
              borderRadius: '12px',
              fontSize: '11px',}}>Failed</span>
          </>
          );
         }
         else {
         return <StatusBadge status={row.status} />
         }
        },
        sortable: true,
        wrap: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="d-flex gap-1">
          <TooltipWidget title="View SDRF">
            <Link
              className="btn btn-warning btn-sm"
            //   target="_blank"
              to={`/application/${window.btoa(row.id)}`}
            >
              <BsEyeFill />
            </Link>
          </TooltipWidget>
        </div>
      ),
      minWidth: "180px",
    },
  ];

  const [selectedRows, setSelectedRows] = useState("");

  const onSelectedRowsChange = (d) => {
    setSelectedRows(d);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getApplication([6], page, filter, perPage);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    setResetPaginationToggle((prev) => !prev);
    getApplication([6], 1, filter, newPerPage);
  };

  const handleSort = (column, direction) => {
    const colMap = {
      "Application ID": "application_id",
      "District": "district_name",
      "Aadhar No": "aadhar_no",
      "Status": "status",
    };
    const field = colMap[column.name] || "";
    setSortBy(field);
    setSortDirection(direction);
    setCurrentPage(1);
    getApplication([6], 1, filter, perPage, field, direction);
  };

  return (
    <>
      <div className="bg-white p-3 rounded p-3 shadow">
        <div className="mb-3">
          <div className="row g-2">
            <div className="col-lg-4 col-md-4">
              <h5 className="text-dark">Final Approved Applications List</h5>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="">
                <input
                  type="text"
                  placeholder="Search Application"
                  className="form-control"
                  value={filter}
                  onChange={(e) => handleSearchInput(e.target.value)}
                  disabled={isLoading}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={isLoading}
              >
                Search
              </button>
            </div>
          </div>
        </div>

        {isApplicationLoaded && (
          <div className="mb-3">
            <small className="text-muted">
              Showing {totalRecords === 0 ? 0 : (currentPage - 1) * perPage + 1} to{" "}
              {totalRecords === 0 ? 0 : Math.min(currentPage * perPage, totalRecords)} of{" "}
              {totalRecords} final approved applications
            </small>
          </div>
        )}
        {/* {selectedRows?.selectedCount > 0 && (
          <div className="alert alert-info d-flex align-items-center p-2">
            <div className="h5 m-0 flex-grow-1">
              {selectedRows?.selectedCount} item selected
            </div>
            <button
              type="button"
              className="btn btn-success"
              onClick={bulkApprove}
            >
              <FaCheck /> Bulk Approve
            </button>
          </div>
        )} */}

        <div>
          {isApplicationLoaded ? (
            <Table
              columns={columns}
              data={application}
            //   selectableRows={true}
              onSelectedRowsChange={onSelectedRowsChange}
              progressPending={isLoading}
              pagination
              paginationServer
              paginationTotalRows={totalRecords}
              paginationDefaultPage={currentPage}
              paginationPerPage={perPage}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              paginationResetDefaultPage={resetPaginationToggle}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              sortServer
              onSort={handleSort}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </>
  );
};

export default FinalApprovedApplicationsList;
